import {
  SELECT_INVENTORY_ITEM,
  FILTERS,
  SET_LOGOUT_AUTH
} from '../actions/Index';

const initState = {
  inventoryId: null,
  expiringVaccineFromDate: null,
  expiringVaccineToDate: null,
  expiredVaccineDate: null,
  vaccineProgramId: '',
  expiredVaccineProgramId: '',
  expiringVaccineProgramId: '',
  returnDate: '',
  returnQuantity: '',
  returnComment: '',
  expiredVaccineId: '',
  returnExpiringVaccineComment: '',
  returnExpiringVaccineQuantity: '',
  returnExpiringVaccineDate: '',
  expiringVaccineId: ''
};

export default function (state = initState, action: any): any {
  const {type, payload} = action;
  switch (type) {
    case SELECT_INVENTORY_ITEM:
      return {
        inventoryId: payload.item
      };
    case FILTERS.EXPIRING_VACCINE_FROM_DATE:
      return {
        ...state,
        expiringVaccineFromDate: payload.fromDate
      };
    case FILTERS.EXPIRING_VACCINE_TO_DATE:
      return {
        ...state,
        expiringVaccineToDate: payload.toDate
      };
    case FILTERS.EXPIRED_VACCINE_DATE:
      return {
        ...state,
        expiredVaccineDate: payload.expiredDate
      };
    case FILTERS.VACCINE_PROGRAM_ID:
      return {
        ...state,
        vaccineProgramId: payload.vaccineProgramId
      };

    case FILTERS.EXPIRED_VACCINE_PROGRAM_ID:
      return {
        ...state,
        expiredVaccineProgramId: payload.expiredVaccineProgramId
      };
    case FILTERS.EXPIRING_VACCINE_PROGRAM_ID:
      return {
        ...state,
        expiringVaccineProgramId: payload.expiringVaccineProgramId
      };
    case FILTERS.RESET_TO_INITIAL_STATE:
      return {
        ...initState
      };
    case FILTERS.RETURN_VACCINES_DETAILS:
      return {
        ...initState,
        returnDate: payload.returnDate,
        returnQuantity: payload.returnQuantity,
        returnComment: payload.returnComment
      };
    case FILTERS.EXPIRED_VACCINE_ID:
      return {
        ...initState,
        expiredVaccineId: payload.expiredVaccineId
      };
    case FILTERS.RETURN_EXPIRING_VACCINES_DETAILS:
      return {
        ...initState,
        returnExpiringVaccineDate: payload.returnExpiringVaccineDate,
        returnExpiringVaccineQuantity: payload.returnExpiringVaccineQuantity,
        returnExpiringVaccineComment: payload.returnExpiringVaccineComment
      };
    case FILTERS.EXPIRING_VACCINE_ID:
      return {
        ...initState,
        expiringVaccineId: payload.expiringVaccineId
      };
    case SET_LOGOUT_AUTH:
      return {
        ...initState
      };
    default:
      return state;
  }
}
